/**
 * Gets a display name for a contact, using available fields in priority order.
 * @param {Object} contact - The contact object
 * @param {string} [fallback=''] - Fallback value if no name fields are available
 * @returns {string} The contact's display name
 */
export const getContactDisplayName = (contact, fallback = '') =>
  contact?.fullName ||
  contact?.linkedinHandle ||
  contact?.email ||
  contact?.personalEmails?.[0] ||
  contact?.workEmails?.[0] ||
  contact?.allEmails?.[0] ||
  fallback;
